import React from 'react';
import {isEmpty} from 'lodash';
import Requirements from 'src/components/scholarship-programs/requirements';
import Card from 'src/components/cards/card';
import CollapsibleSection from 'src/components/collapsible-section';
import {useHistory, useLocation} from 'react-router-dom';
import useBrandName from 'src/hooks/use-brand-name';
import {useMediaQuery} from 'src/hooks/use-media-query';
import {CriterionOr} from 'src/types/scholarship';
import {SubmissionDeadline} from 'src/components/scholarships-checklist/scholarship-checklist/scholarship-checklist-items/date-status-tag';
import {SubmissionPeriod} from 'src/types/college-profile';
import {EducationPhase} from 'src/types/enums';

interface Props {
  scholarshipProgram: {
    name: string;
    criteria: $TSFixMe[];
    criterionOr: CriterionOr;
    eligibilityRequirements: string[];
    submissionDeadline: SubmissionDeadline;
    applicationDeadline: Date;
    minCreditHours: number;
    submissionPeriods: SubmissionPeriod[];
    eligiblePhase: EducationPhase;
    _id: string;
  };
  showsHighSchoolList?: boolean;
  brandName?: string;
}

const EligibilityCriteriaCard = ({scholarshipProgram, showsHighSchoolList, brandName}: Props) => {
  const history = useHistory();
  const location = useLocation();
  const mq = useMediaQuery();

  const onHighSchoolListClick = (criterionId) => {
    history.replace({
      pathname: `${location.pathname}/high-schools/${scholarshipProgram._id}/${criterionId}`,
      state: {skipScrolling: true},
    });
  };

  const criteria = [...scholarshipProgram.criteria];

  if (!isEmpty(scholarshipProgram.criterionOr)) {
    criteria.push(scholarshipProgram.criterionOr);
  }

  if (!brandName) {
    return null;
  }

  return (
    <Card className="college-profile-eligibility-criteria scholarship-program-info">
      <CollapsibleSection
        title="Eligibility Criteria"
        subtitle={`To Earn ${brandName} Micro-Scholarships`}
        disableCollapse={mq.MD_AND_UP}
      >
        <div className="college-profile-header-spacing">
          <Requirements
            requirements={scholarshipProgram.eligibilityRequirements}
            deadline={scholarshipProgram.submissionDeadline}
            onHighSchoolListClick={showsHighSchoolList && onHighSchoolListClick}
            applicationDeadline={scholarshipProgram.applicationDeadline}
            minCreditHours={scholarshipProgram.minCreditHours}
            criteria={criteria}
            submissionPeriods={scholarshipProgram.submissionPeriods}
            eligiblePhase={scholarshipProgram.eligiblePhase}
          />
        </div>
      </CollapsibleSection>
    </Card>
  );
};

const EligibilityCriteriaCardWithBrandName = (props) => {
  const brandName = useBrandName();

  return <EligibilityCriteriaCard {...props} brandName={brandName} />;
};

export default EligibilityCriteriaCardWithBrandName;
